export default "__VITE_ASSET__Biqx4tS4__"